import { cn } from '@/lib/utils'
import type { StorageTransferStatus } from '@/types/storage'

/**
 * A plan's status, in one place.
 *
 * Shared by the list and the detail page so the same plan cannot read as two
 * different things depending on which screen somebody opened.
 */
const STATUS_STYLE: Record<StorageTransferStatus, string> = {
  DRAFT: 'bg-muted text-muted-foreground',
  READY: 'bg-sky-100 text-sky-800',
  IN_PROGRESS: 'bg-amber-100 text-amber-900',
  COMPLETED: 'bg-emerald-100 text-emerald-800',
  CANCELLED: 'bg-gray-100 text-gray-500',
}

/**
 * "Approved", not "ready". READY is what the column holds; what it MEANS to
 * the person reading it is that somebody approved the plan and it is now
 * freezing the source.
 *
 * Exported for the plan's print sheet (`TransferPrintSheet.tsx`), which states
 * the status in a sentence rather than this chip.
 */
export const STATUS_WORD: Record<StorageTransferStatus, string> = {
  DRAFT: 'draft',
  READY: 'approved',
  IN_PROGRESS: 'in progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
}

export function TransferStatusChip({ status }: { status: StorageTransferStatus }) {
  return (
    <span
      className={cn(
        'whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide',
        STATUS_STYLE[status],
      )}
    >
      {STATUS_WORD[status]}
    </span>
  )
}
